import { keycloakService } from '@/plugins';

export default {
  companies: (state) => state.companies,
  partners: (state) => state.partners,
  selectedCompany: (state) => state.selectedCompany,
  selectedPartner: (state) => state.selectedPartner,
  detailsModalToggler: (state) => state.toggleDetailsModal,
  detailsModalConfig: (state) => state.detailsModalConfig,
  companyGames: (state) => state.companyGames,
  selectedGame: (state) => state.selectedGame,
  companyGameRounds: (state) => state.companyGameRounds,
  companyGameDetails: (state) => state.companyGameDetails,
  selectedRound: (state) => state.selectedRound,
  players: (state) => state.players,
  tags: (state) => state.tags,
  assets: (state) => state.assets,
  selectedAssetGame: (state) => state.selectedAssetGame,
  thumbnail: (state) => state.thumbnail,
  bootstrap: (state) => state.bootstrap,
  reportsGames: (state) => state.reportsGames,
  selectedReportsGame: (state) => state.selectedReportsGame,
  selectedPromotion: (state) => state.selectedPromotion,
  promotions: (state) => state.promotions,
  promotionPlayers: (state) => state.promotionPlayers,
  promotionDetails: (state) => state.promotionDetails,
  reportsPlayers: (state) => state.reportsPlayers,
  translation: (state) => (key) => state.translations[key],
  translations: (state) => state.translations,
  pusherMessage: (state) => state.pusherMessage,
  snackbarNotification: (state) => state.snackbarNotification,
  importFile: (state) => state.importFile,
  acceptHeader: (state) => state.acceptHeader,
  isMobile: (state) => state.isMobile,
  toolbarTitle: (state) => state.toolbarTitle,
  cancelControllers: (state) => state.cancelControllers,
  loading: (state) => state.loading,
  currencyValidation: (state) => state.currencyValidation,
  promotionErrorList: (state) => state.promotionErrorList,
  isUnifiedCurrency: (state) => state.unifiedCurrency,
  isExcludeInternal: (state) => state.excludeInternal,
  gameAssetsDetails: (state) => state.gameAssetsDetails,
  assetsUploadDialog: (state) => state.uploadAssetsDialog,
  userRole: () => keycloakService.userRole,
  deviceDefinitions(getters) {
    return {
      grow: getters.isMobile,
      background: getters.isMobile ? 'background' : 'transparent',
      tabs: getters.isMobile ? 'pa-0' : 'pa-4',
      view: getters.isMobile ? 'pa-4' : 'pa-0',
    };
  },
  footerProps: (state, getters) => ({
    'items-per-page-options': state.rowsCount,
    'items-per-page-text': getters.isMobile ? state.translations.rows : state.translations.rowsPerPage,
    'page-text': state.translations.pageText,
  }),
  tournamentDetails: (state) => state.tournamentDetails,
  boostBootstrap: (state) => state.boostBootstrap,
  boostCompanies: (state) => state.boostCompanies,
  isBoostUnavailable: (state) => state.boostUnavailable,
  authorizedNavigation: (state) => (state.boostUnavailable
    ? keycloakService.authorizedNavigation.filter((item) => item.link !== '/boost')
    : keycloakService.authorizedNavigation),
};
